export const formatNumber = (
  number: number,
  options: Intl.NumberFormatOptions,
  locale = 'en-US',
) => new Intl.NumberFormat(locale, options).format(number);
